module.exports = __webpack_public_path__ + "assets/img/crm-new.0d3c14e7.svg";